import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
export const OrganizationDelete = ({ organization, onDeletion }) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.OrganizationService(organization.url)
      .makeDeleteRequest()
      .then((response) => {
        onDeletion()
        dispatch(
          showSuccessToast(`Deleted organization ${organization.code}`, '')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            `Could not delete organization ${organization.code}`,
            errors.response.data
          )
        )
      })
  }
  let message = `Are you sure you want to delete ${organization.name}-${organization.code}?`
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body={message}
        confirmText={`Delete ${organization.name}-${organization.code}?`}
        confirmBSStyle="danger"
        title="Deleting Organization"
      >
        <ReactBootstrap.NavDropdown.Item block size="sm">
          <i class="fa fa-trash" aria-hidden="true"></i>{' '}
          <span className="ml-1"> Delete</span>
        </ReactBootstrap.NavDropdown.Item>
      </components.Confirm>
    </>
  )
}
